import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, NgModule, OnInit, Optional } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { WzbButtonModule } from '@wizbii/angular-ui';

@Component({
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent implements OnInit {
  constructor(private readonly route: ActivatedRoute, @Optional() @Inject(RESPONSE) private readonly response: any) {}

  ngOnInit() {
    if (this.response) {
      this.response.statusCode = 404;
      this.response.statusMessage = 'Not Found';
    }
  }
}

@NgModule({
  imports: [CommonModule, RouterModule, WzbButtonModule, MatIconModule],
  exports: [NotFoundComponent],
  declarations: [NotFoundComponent],
})
export class NotFoundModule {}
